var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m332.08 254.24c-20.719 4.4805-37.52 21.281-42.559 41.441-9.5195 40.879 26.32 77.281 67.199 68.32 20.719-4.4805 37.52-21.281 42.559-41.441 10.082-40.879-25.758-77.277-67.199-68.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.72 279.44c-12.879-3.3594-25.762 5.0391-29.68 17.359l-12.32 38.078c-6.1602 18.48-18.48 34.16-36.398 42-10.641 5.0391-22.398 7.2812-34.16 7.2812h-54.879c-22.961 0-44.801 11.762-57.121 31.359l-54.879 87.359c-6.7188 11.199-5.0391 26.32 5.6016 34.16 4.4805 2.8008 8.9609 4.4805 14 4.4805 7.8398 0 16.238-3.9219 20.719-11.199l42.559-68.32v68.879c0 8.3984 6.7188 15.121 15.121 15.121h86.238c8.3984 0 15.121-6.7188 15.121-15.121v-103.04c3.9219-1.1211 8.3984-1.6797 12.32-3.3594 34.16-12.32 59.922-39.199 71.121-73.922l12.879-40.32c4.4805-12.879-2.8008-27.438-16.242-30.797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.24 187.04h28l24.078 38.078c5.0391 7.2812 15.68 7.2812 20.719 0l24.078-38.078h28c13.441 0 24.078-10.641 24.078-24.078l0.007813-124.88c0-13.441-10.641-24.078-24.078-24.078h-124.88c-13.441 0-24.078 10.641-24.078 24.078v124.88c0 12.883 11.199 24.082 24.078 24.082zm21.84-106.96c-5.6016-5.6016-5.6016-14.559 0-20.16 5.6016-5.6016 14.559-5.6016 20.16 0l20.719 20.719 20.719-20.719c5.6016-5.6016 14.559-5.6016 20.16 0 5.6016 5.6016 5.6016 14.559 0 20.16l-20.719 20.719 20.719 20.719c5.6016 5.6016 5.6016 14.559 0 20.16-2.8008 2.8008-6.1602 3.9219-10.078 3.9219-3.3594 0-7.2812-1.1211-10.078-3.9219l-20.719-20.719-20.719 20.719c-2.8008 2.8008-6.1602 3.9219-10.078 3.9219-3.3594 0-7.2812-1.1211-10.078-3.9219-5.6016-5.6016-5.6016-14.559 0-20.16l20.719-20.719z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.550781,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 104.359375,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.347656,
    y: 644,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 142.242188,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 155.628906,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 174.617188,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 204.410156,
    y: 644,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 224.453125,
    y: 644,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.453125,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 274.121094,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 294.164062,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.972656,
    y: 644,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 317.570312,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336.5625,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 366.242188,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 386.789062,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 406.027344,
    y: 644,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 426.070312,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 446.003906,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 464.992187,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 672,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 82.183594,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.992188,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 115.226562,
    y: 672,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 154.152344,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 167.535156,
    y: 672,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 187.46875,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216.207031,
    y: 672,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 239.640625,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.878906,
    y: 672,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.8125,
    y: 672,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.492188,
    y: 672,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.015625,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.820312,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.058594,
    y: 672,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.65625,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.648438,
    y: 672,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.242188,
    y: 672,
    xlinkHref: "#b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjection);
export default __webpack_public_path__ + "static/media/objection.1d4cf06e00d8587b92d3633b17915f7f.svg";
export { ForwardRef as ReactComponent };